import Slideout from "slideout";

import * as Website from '../Config/Website.js';

const DrawerMenu = {
  instance: null,
  element: {
    menu: '#js-drawerMenu',
    panel: '#js-drawerMenuPanel',
    toggle: '#js-drawerMenuToggle',
    close: '#js-drawerMenuPanel, #js-drawerMenu .js-scroll, .p-ham .js-scroll ,.js-ham',
    dropdown: '.js-drawerDropdown'
  },
  init() {
    const menuElm = document.querySelector(this.element.menu);
    const panelElm = document.querySelector(this.element.panel);
    if(menuElm === null) return;
    if(panelElm === null) return;
    this.instance = new Slideout({
      panel: panelElm,
      menu: menuElm,
      duration: 10
    });
    this.toggle();
    this.close();
    this.dropdown();
    this.instance.on('open', function(){
      if(typeof Iscroll !== "undefined" && Iscroll.instance) {
        Iscroll.stop();
      }
    });
    this.instance.on('close', function() {
      if(typeof Iscroll !== "undefined" && Iscroll.instance) {
        Iscroll.start();
      }
    });
  },
  toggle() {
    document.addEventListener('click', (e) => {
      let target = null;
      if(e.target.closest(DrawerMenu.element.toggle)) {
        target = e.target.closest(DrawerMenu.element.toggle);
      } else if(e.target.matches(DrawerMenu.element.toggle)) {
        target = e.target;
      }
      if(target) {
        this.instance.toggle();
      }
    });
  },
  close() {
    document.addEventListener('click', (e) => {
      let target = null;
      if(e.target.closest(this.element.close)) {
        target = e.target.closest(this.element.close);
      } else if(e.target.matches(this.element.close)) {
        target = e.target;
      }
      if(target) {
        this.instance.close();
      }
    });
  },
  dropdown() {
    document.addEventListener('click', (e) => {
      const dropdownElms = document.getElementsByClassName("js-drawerDropdown");
      let target = null;
      if(e.target.closest(this.element.dropdown)) {
        target = e.target.closest(this.element.dropdown);
      } else if(e.target.matches(this.element.dropdown)) {
        target = e.target;
      }

      if(target) {
        if(Website.status.isDesktop && Website.status.winWidth >= Website.options.shiftpoint) return;
        const otherElms = Array.from(dropdownElms).filter(elm => elm !== target);
        if(Website.status.winWidth >= Website.options.shiftpoint) {
          otherElms.map(elm => elm.classList.remove(Website.classList.act));
        }
        target.classList.toggle(Options.act);
        if(target.classList.contains(Options.act)) {
          target.nextElementSibling.style.height = target.nextElementSibling.scrollHeight + "px";
        } else {
          target.nextElementSibling.style.height = "0px";
        }
      }
    });
  },
  dropdownClose(e) {
    const dropdownElms = document.getElementsByClassName("js-drawerDropdown");
    if(Website.status.isDesktop) {
      for(const dropdownElm of dropdownElms) {
        dropdownElm.classList.remove(Options.act);
        dropdownElm.nextElementSibling.style.height = "";
      }
    }
  },
  menuClose() {
    this.instance.close();
  },
  menuOpen() {
    this.instance.open();
  }
}

export default DrawerMenu;